// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"293":"component---src-pages-index-js","510":"component---src-pages-terms-js","826":"component---src-pages-delete-account-js"}[chunkId] || chunkId) + "-" + {"293":"d33e8481f7042451067e","454":"794562760ecce700629a","510":"d98e69543783563c89be","826":"b02ebaf78c4cfbf8d28c"}[chunkId] + ".js";
};